export const getExpressPaymentMethodsAvailability = ({
    areAllSelectedTicketsFree,
    areTicketsSelected,
    hasAsyncApplePayErrors,
    isExpressApplePayEnabled,
    isExpressGooglePayEnabled,
    isExpressPayPalEnabled,
}: {
    areAllSelectedTicketsFree: boolean;
    areTicketsSelected: boolean;
    hasAsyncApplePayErrors: boolean;
    isExpressApplePayEnabled: boolean;
    isExpressGooglePayEnabled: boolean;
    isExpressPayPalEnabled: boolean;
}): Record<
    | 'shouldShowApplePayButton'
    | 'shouldShowGooglePayButton'
    | 'shouldShowPaypalButton',
    boolean
> => {
    const areOnlyFreeTicketsSelected =
        areAllSelectedTicketsFree && areTicketsSelected;

    if (areOnlyFreeTicketsSelected) {
        return {
            shouldShowApplePayButton: false,
            shouldShowGooglePayButton: false,
            shouldShowPaypalButton: false,
        };
    }

    const shouldShowApplePayButton =
        isExpressApplePayEnabled && !hasAsyncApplePayErrors;

    const shouldShowGooglePayButton =
        !shouldShowApplePayButton && isExpressGooglePayEnabled;

    const shouldShowPaypalButton =
        isExpressPayPalEnabled &&
        !shouldShowApplePayButton &&
        !shouldShowGooglePayButton;

    return {
        shouldShowApplePayButton,
        shouldShowGooglePayButton,
        shouldShowPaypalButton,
    };
};
